// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1cBUcomtkoc_sm8CUriwG8","datePicker":"tmihMyY5OrIRD110Sm1MJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DateRange/styles.css
// module id = 1061
// module chunks = 0